import React, { useEffect, useState } from "react";
import ContentHeading from "../../../components/layout/content/ContentHeading";
import InputTextField from "../../../components/input/inputTextField";
import TableCustom from "../../../components/table/tableCustom";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { useDispatch } from "react-redux";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { SearchOutlined } from "@mui/icons-material";
import { debouncedApiCall } from "../../../utils/app.utils";
import { CourseAnnualDetailAPI } from "../../../api/course-annual-detail/course-annual-detail.api";
import { dateToView } from "../../../utils/date.utils";
import { icons } from "../../../assets/icons/icons";
import {
  alertActive,
  alertError,
  alertSuccess,
} from "../../../components/alert/swal";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import {
  ButtonOutlined,
  ButtonPrimary,
} from "../../../components/button/ButtonCustoms";
import ModalCustom from "../../../components/modal/ModalCustom";
import { numberFormat } from "../../../utils/common";
import { roomMeetingServiceApi } from "../../../api/booking-room-fees/booking-room-fees.api";
import { useMediaQuery, useTheme } from "@mui/material";

type Props = {};

const BookingFeesManagementContainer: React.FC<Props> = (props: Props) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));

  const [data, setData] = useState<any[]>([]);

  const [inputValue, setInputValue] = useState<any>({
    id_service_fees: "",
    service_fees_name: "",
    service_fees_thb: "",
    service_fees_usd: "",
    service_fees_unit: "",
    room_meeting_service_desc: ""
  });

  const [isModalForm, setisModalForm] = useState<boolean>(false);
  const [mode, setMode] = useState<string>("ADD");

  const [search, setSearch] = useState<string>("");

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const handleCloseModal = () => {
    setisModalForm(false);
    setInputValue({
      id_service_fees: "",
      service_fees_name: "",
      service_fees_thb: "",
      service_fees_usd: "",
      service_fees_unit: "",
    });
  };

  const getData = async () => {
    let query: any = {
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
      keyword: search ?? "",
    };

    const res = await roomMeetingServiceApi.getRoomMeetingServiceList(query);
    const data = res.data;
    if (data.status < 300) {
      const formattedData =
        res.data?.data?.items?.map((item: any) => ({
          id_service_fees: item.id_room_metting_service || "",
          service_fees_name: item.room_metting_service_name || "",
          service_fees_thb: item.room_metting_service_amount || "",
          service_fees_usd: item.room_metting_service_amount_usd || "",
          service_fees_unit: item.unit || "",
          status: item.status || "",
        })) ?? [];
      setData(formattedData);
      setTotalItems(res.data?.data?.meta?.totalItems || 0);
    } else {
      setData([]);
    }
  };

  const handleDelete = async (id_service_fee: number) => {
    if (id_service_fee) {
      alertActive(
        "ลบค่าบริการ",
        "ท่านต้องการลบค่าบริการ ใช่หรือไม่",
        undefined,
        undefined,
        async () => {
          dispatch(setLoading());
          await roomMeetingServiceApi.deleteRoomMeetingService(
            +id_service_fee
          )
            .then((res) => {
              if (res.status < 300) {
                alertSuccess(
                  "ลบค่าบริการ เรียบร้อย",
                  undefined,
                  undefined,
                  () => {
                    getData();
                  }
                );
              }
            })
            .catch(() => {
              alertError("ลบค่าบริการ ไม่สำเร็จ");
            })
            .finally(() => {
              dispatch(unsetLoading());
            });
        }
      );
    }
    return;
  };

  const headCells = [
    {
      id: "no",
      width: 50,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "ลำดับ",
    },
    {
      id: "period",
      width: 150,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "ชื่อบริการ",
    },
    {
      id: "period",
      width: 75,
      sortable: false,
      disablePadding: false,
      align: "center",
      label: "ค่าบริการ (THB)",
    },
    {
      id: "period",
      width: 75,
      sortable: false,
      disablePadding: false,
      align: "center",
      label: "ค่าบริการ (USD)",
    },
    {
      id: "period",
      width: 75,
      sortable: false,
      disablePadding: false,
      align: "center",
      label: "หน่วย",
    },
    {
      id: "period",
      width: 75,
      sortable: false,
      disablePadding: false,
      align: "center",
      label: "วันที่สร้าง/แก้ไข",
    },
    {
      id: "action",
      width: 50,
      sortable: false,
      class: matches && data?.length > 0,
      disablePadding: false,
      align: "start",
      label: "",
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id_service_fees,
      service_fees_name,
      service_fees_thb,
      service_fees_usd,
      service_fees_unit,
      created_date,
    } = objData;

    const objRenderData = {
      key: id_service_fees,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "start",
          label: no ?? "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: service_fees_name ?? "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: service_fees_thb ? numberFormat(service_fees_thb) : "",
        },
        {
          option: "TEXT",
          align: "center",
          label: service_fees_usd ? numberFormat(service_fees_usd) : "",
        },
        {
          option: "TEXT",
          align: "center",
          label: service_fees_unit ?? "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: created_date ? dateToView(created_date) : "",
        },
        {
          option: "COMPONENT",
          align: "center",
          class: matches,
          component: (
            <div
              style={{
                display: "flex",
                textAlign: "center",
                justifyContent: "center",
              }}
            >
              <img
                onClick={() => {
                  setMode("VIEW");
                  setisModalForm(true);
                  getDataDetail(id_service_fees);
                }}
                src={icons.eye}
                alt="eye"
                style={{ cursor: "pointer" }}
              />
              <img
                onClick={() => {
                  setMode("UPDATE");
                  setisModalForm(true);
                  getDataDetail(id_service_fees);
                }}
                src={icons.edit}
                alt="edit"
                style={{ cursor: "pointer", margin: "0px 12px" }}
              />
              <img
                src={icons.bag_cross}
                alt="bag_cross"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setMode("DELETE");
                  handleDelete(id_service_fees);
                }}
              />
            </div>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  useEffect(() => {
    getData();
  }, [page, pageLimit, sortBy, sortType, search]);

  const handleSubmit = async () => {
    const title =
      mode === "ADD"
        ? "เพิ่มค่าบริการ"
        : mode === "VIEW"
          ? "ค่าบริการ"
          : "แก้ไขค่าบริการ";

    dispatch(setLoading());

    const body = {
      room_metting_service_name: inputValue.service_fees_name,
      room_metting_service_amount: inputValue.service_fees_thb,
      room_metting_service_amount_usd: inputValue.service_fees_thb,
      room_meeting_service_desc: inputValue.room_meeting_service_desc,
      status: "active",
      unit: inputValue.service_fees_unit,
    };

    try {
      let response;

      if (inputValue.id_service_fees) {
        response = await roomMeetingServiceApi.updateARoomMeetingService(
          inputValue.id_service_fees,
          body
        );
      } else {
        response = await roomMeetingServiceApi.createRoomMeetingService(body);
      }

      if (response.status < 300) {
        alertSuccess(title, `${title} สำเร็จ`, undefined, () => {
          getData();
          handleCloseModal();
        });
      }
    } catch (err: any) {
      alertError(title, err?.response?.data?.message || `${title} ไม่สำเร็จ`);
    } finally {
      dispatch(unsetLoading());
    }
  };

  const handleChange = (name: string, value: string) => {
    setInputValue((prev: any) => ({ ...prev, [name]: value }));
  };

  const getDataDetail = async (id_service_fee: number) => {
    try {
      const res = await roomMeetingServiceApi.getRoomMeetingServiceById(
        id_service_fee
      );
      const data = res.data;

      if (data.status < 300) {
        setInputValue({
          id_service_fees: data?.data?.id_room_metting_service || "",
          service_fees_name: data?.data?.room_metting_service_name || "",
          service_fees_thb: data?.data?.room_metting_service_amount || "",
          room_meeting_service_desc: data?.data?.room_meeting_service_desc || "",
          service_fees_usd: data?.data?.room_metting_service_amount_usd || "",
          service_fees_unit: data?.data?.unit || "",
          status: data?.data?.status || "",
        });
      } else {
        setInputValue({
          id_service_fees: "",
          service_fees_name: "",
          service_fees_thb: "",
          service_fees_usd: "",
          service_fees_unit: "",
        });
      }
    } catch (error) {
      console.error("Error fetching details:", error);
    }
  };

  return (
    <div>
      <ModalCustom
        open={isModalForm}
        title={
          mode === "ADD"
            ? "เพิ่มค่าบริการ"
            : mode === "VIEW"
              ? "ค่าบริการ"
              : "แก้ไขค่าบริการ"
        }
        subTitle={""}
        onClose={handleCloseModal}
        component={
          <div className="w-full">
            <section className="grid grid-cols-12 gap-x-6 gap-y-6">
              <article className="col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-12 space-y-2">
                <InputTextField
                  value={inputValue.service_fees_name}
                  heading="ชื่อบริการ"
                  required
                  placeholder="ระบุชื่อบริการ"
                  onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleChange("service_fees_name", e.target.value)
                  }
                  disabled={mode === "VIEW"}
                />
              </article>
              <article className="col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-12 space-y-2">
                <InputTextField
                  value={inputValue.room_meeting_service_desc}
                  heading="รายละเอียดบริการ"
                  required
                  row={3}
                  inputHeight={"auto"}
                  multiline
                  disablePaddingMultiline
                  placeholder="ระบุรายละเอียดบริการ"
                  onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleChange("room_meeting_service_desc", e.target.value)
                  }
                  disabled={mode === "VIEW"}
                />
              </article>

              <article className="col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-12 space-y-2">
                <InputTextField
                  value={inputValue.service_fees_thb}
                  type="number"
                  heading="ค่าบริการ (THB)"
                  required
                  placeholder="ระบุค่าบริการ (THB)"
                  onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleChange("service_fees_thb", e.target.value)
                  }
                  disabled={mode === "VIEW"}
                />
              </article>

              <article className="col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-12 space-y-2">
                <InputTextField
                  value={inputValue.service_fees_usd}
                  heading="ค่าบริการ (USD)"
                  type="number"
                  required
                  placeholder="ระบุค่าบริการ (USD)"
                  onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleChange("service_fees_usd", e.target.value)
                  }
                  disabled={mode === "VIEW"}
                />
              </article>

              <article className="col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-12 space-y-2">
                <InputTextField
                  value={inputValue.service_fees_unit}
                  heading="หน่วย"
                  required
                  placeholder="ระบุหน่วย"
                  onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleChange("service_fees_unit", e.target.value)
                  }
                  disabled={mode === "VIEW"}
                />
              </article>
            </section>

            <div className="mt-6 w-full flex justify-center gap-4 items-center">
              <span>
                <ButtonOutlined
                  onClick={handleCloseModal}
                  mode="del"
                  buttonName="ยกเลิก"
                />
              </span>
              {mode !== "VIEW" && (
                <span>
                  <ButtonPrimary
                    mode="done"
                    buttonName={"ยืนยัน"}
                    disabled={
                      !inputValue.service_fees_name ||
                      !inputValue.service_fees_thb ||
                      !inputValue.service_fees_usd ||
                      !inputValue.service_fees_unit
                    }
                    onClick={handleSubmit}
                  />
                </span>
              )}
            </div>
          </div>
        }
      />

      <ContentHeading
        title={"จัดการค่าบริการ"}
        detail="กรุณาเลือกรายการที่ท่านต้องการ"
      />

      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 lg:col-span-3 md:col-span-3 sm:col-span-3">
          <InputTextField
            startAdornment={<SearchOutlined />}
            placeholder="ค้นหา ชื่อบริการ"
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              debouncedApiCall({
                searchItem: e.target.value,
                setItem: setSearch,
              })
            }
          />
        </article>

        <article className="w-full col-span-12 lg:col-span-9 md:col-span-9 sm:col-span-9 flex justify-end">
          <ButtonPrimary
            onClick={() => {
              setMode("ADD");
              setisModalForm(true);
            }}
            mode="add"
            buttonName={"เพิ่มบริการ"}
          />
        </article>
      </div>

      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={1440}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            data &&
            data.map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={handleRequestSort}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>
    </div>
  );
};

export default BookingFeesManagementContainer;
